import { queryOptions, useQuery } from '@tanstack/react-query';

import type { CommunityProfileFilters } from './types';

import { fetchJson } from '../fetch';
import { QueryKeys } from '../keys';
import { communityProfilesCountSchema } from './schemas';

const communityProfilesCountQueryOptions = (filters: CommunityProfileFilters, enabled: boolean) =>
  queryOptions({
    queryKey: QueryKeys.community.count.metadata(filters),
    queryFn: async () => {
      // `perPage: 1` keeps the payload to a single record; `totalResults` is a separate COUNT and stays accurate.
      const { pagination } = await fetchJson('/community', {
        schema: communityProfilesCountSchema,
        params: {
          name: filters.name,
          activityIds: filters.activityIds,
          openToWork: filters.openToWork || null,
          regions: filters.regions,
          perPage: 1,
        },
      });

      return pagination.totalResults;
    },
    staleTime: 30 * 1000,
    gcTime: 2 * 60 * 1000,
    enabled,
  });

export const useCommunityProfilesCount = (filters: CommunityProfileFilters, options?: { enabled?: boolean }) => {
  return useQuery(communityProfilesCountQueryOptions(filters, options?.enabled ?? true));
};
